import React from 'react';

import { Col, Row, Spin, Modal, Button } from 'antd';
import useFetchRecordCashoutDetail from './hooks/useFetchRecordCashoutDetail';
import { hot } from 'react-hot-loader';

export default hot(module)(function CashoutDetails({ open, id, cancel }) {
	const { state } = useFetchRecordCashoutDetail(id);

	let PHP = new Intl.NumberFormat('PH', { style: 'currency', currency: 'PHP' });

	return (
		<>
			<Modal
				title="Cashout Details"
				open={open}
				onCancel={cancel}
				footer={null}
				mask={true}
				className="topup_modal">
				<Row style={{ margin: '40px auto' }}>
					{state._isLoading && <Spin style={{ marginBottom: '20px', float: 'right' }} />}
					<Col span={24} className="topup_col">
						<p>
							User Id: <br />
							<span className="blue">{state.data?.wallet?.user_id || '--'}</span>
						</p>
						<p>
							Cashout Date: <br />
							<span className="blue">{state.data?.wallet?.cashout_date || '--'}</span>
						</p>
						<p>
							Wallet Id: <br /> <span className="blue">{state.data?.wallet?.wallet_id || '--'}</span>
						</p>
						<p>
							Channel: <br />
							<span className="blue">{state.data?.wallet?.channel || '--'}</span>
						</p>
						<p>
							Transfer ID: <br />
							<span className="blue">{state.data?.wallet?.transfer_id || '--'}</span>
						</p>
						<p>
							Receivable Amount:
							<br />
							<span className="blue">
								{PHP.format(Number(state.data?.wallet?.receivable_amount).toFixed(2)) || '--'}
							</span>
						</p>
						<p>
							Request ID: <br />
							<span className="blue">{state.data?.wallet?.reference_number || '--'}</span>
						</p>
						<p>
							Status: <br />
							<span className="status">{state.data?.wallet?.status || '--'}</span>
						</p>
						<p>
							Total Amount:
							<br />
							<span className="blue">
								{PHP.format(Number(state.data?.wallet?.total_amount).toFixed(2)) || '--'}
							</span>
						</p>
						<div style={{ float: 'right' }}>
							<Button size="medium" type="primary" onClick={cancel}>
								Close
							</Button>
						</div>
					</Col>
				</Row>
			</Modal>
		</>
	);
});
